import i18n from '@/plugins/i18n';
import { BYTES_TO_MB_CONVERSION_VALUE } from '@/utils/templates/databaseTemplate/database.constants';
const resourceMONGOGraphs = () => ({
  saturationCharts: [
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.queuesReadsAndWrites'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#f7507f', '#fdfcac'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_mongodb_queues_reads,meter_mongodb_queues_writes',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.countPerMinute'),
      },
      show: true,
      showForSingleSeries: true,
      showMetricDropdown: true,
      showmetricRate: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t(
          'dbm.replicatesWithLargestreadQueuesandWriteQueues',
        ),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#f7507f', '#fdfcac'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName:
        'meter_mongodb_replicates_with_largest_reads_queues,meter_mongodb_replicates_with_largest_write_queues',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.countPerMinute'),
      },
      showMetricDropdown: true,
      showLegendForSeries: true,
      showmetricRate: true,
    },
  ],
  usageCharts: [
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.maxMemoryUsage'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#fdfcac'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_mongodb_data_size',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.mbPerMinute'),
      },
      showLegendForSeries: true,
      showmetricRate: true,
      aggregation: '/',
      aggregationNum: BYTES_TO_MB_CONVERSION_VALUE,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.percentageOfClientConnectionsUsed'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#f7507f'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_mongodb_percentage_client_connection_used',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.percentagePerMinute'),
      },
      showLegendForSeries: true,
      showmetricRate: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.numberOfPageFaultsPerHost'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#fdfcac'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_mongodb_no_of_page_faults',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.countPerMinute'),
      },
      showLegendForSeries: true,
      showmetricRate: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.numberOfAssets'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#f7507f'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_mongodb_no_of_asserts',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.countPerMinute'),
      },
      showLegendForSeries: true,
      showmetricRate: true,
    },
  ],
});

export default resourceMONGOGraphs;
